import React,{useState} from 'react'
import Navbar from '../../components/Navbar/Index'
import Sidebar from '../../components/Sidebar/Index'
import MySkill from '../../components/Skill.js/Index.'

const Skill = () => {
    const [isOpen,setOpen] = useState(false)
    const toggle = () => {
        setOpen(!isOpen)
    }
    return (
        <div id="skill">
           <Sidebar isOpen={isOpen} toggle={toggle}/>
            <Navbar toggle={toggle}/>
            <MySkill/>
        </div>
    )
}

export default Skill
